// ธีม สว่าง/มืด/ตามระบบ — เก็บใน localStorage (index.html ตั้งค่าก่อน React โหลดกันจอกระพริบ)
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { THEME_KEY } from "../services/config";

const ThemeContext = createContext(null);
const mq = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null);
const readPref = () => {
  try {
    return localStorage.getItem(THEME_KEY) || "system";
  } catch (e) {
    return "system";
  }
};

export function ThemeProvider({ children }) {
  const [pref, setPref] = useState(readPref);
  const [sysDark, setSysDark] = useState(() => !!mq()?.matches);
  useEffect(() => {
    const m = mq();
    if (!m) return undefined;
    const fn = (e) => setSysDark(e.matches);
    m.addEventListener ? m.addEventListener("change", fn) : m.addListener(fn);
    return () => (m.removeEventListener ? m.removeEventListener("change", fn) : m.removeListener(fn));
  }, []);
  const resolved = pref === "system" ? (sysDark ? "dark" : "light") : pref;
  useEffect(() => {
    document.documentElement.dataset.theme = resolved;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", resolved === "dark" ? "#12100e" : "#ffffff");
  }, [resolved]);
  const value = useMemo(
    () => ({
      pref,
      theme: resolved,
      setTheme: (t) => {
        setPref(t);
        try {
          localStorage.setItem(THEME_KEY, t);
        } catch (e) {
          /* ข้าม */
        }
      },
      toggle: () => {
        const t = resolved === "dark" ? "light" : "dark";
        setPref(t);
        try {
          localStorage.setItem(THEME_KEY, t);
        } catch (e) {
          /* ข้าม */
        }
      },
    }),
    [pref, resolved]
  );
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
